import axios, { AxiosInstance } from "axios";

// Get API base URL from environment variable, fallback to default
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://localhost:7184/api";

export const api: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: { Accept: "application/json" },
});
